module.exports = __webpack_public_path__ + "img/app-lieqi.45a0e083.webp";